import { render, staticRenderFns } from "./FeeRuleInput.vue?vue&type=template&id=2bcf9e7b&"
import script from "./FeeRuleInput.vue?vue&type=script&lang=js&"
export * from "./FeeRuleInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports